$(function() {
  $('#copyButton').on('click', function() {
    const copyTarget = $('#copyTarget')
    const copyTargetText = copyTarget.text()
    navigator.clipboard.writeText(copyTargetText).then(
      () => alert('コピーしました')
    )
  })
})